module.exports = __webpack_public_path__ + "img/a2_1.bae0e6ff.png";